module.exports = __webpack_public_path__ + "img/logo-black-sm.faa5ee30.svg";